import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'
import moment from '../../../lib/moment.js'
import get from 'lodash/get'
import set from 'lodash/set'
import { Container, Button } from 'reactstrap'
import { css } from '@emotion/core'
import { BeatLoader } from 'react-spinners'
import {
  modalAction,
  authAction,
  reportAction,
} from './../../../actions/'
import {
  modalSelector,
  authSelector,
  reportSelector,
} from './../../../selectors'
import Searchbar from '../../../components/searchbar-report/compensate-work'
import CompensateWorkTable from '../../../components/report/table/compensate-work'
import { CancelCompensateWorkForm } from '../../../components/report/form/cancel-compensate-work'
import withLayout from '../../../helpers/withLayout'
import CustomModalMessage from '../../../components/modal-message'
import { Compensate } from '../../../components/report/form/show-compensate'
import * as reportHelper from '../../../components/report/helpers/report'

class CompensateWorkReport extends React.Component {
  static getDerivedStateFromProps(nextProps, prevState) {
    const tempState = prevState
    if (get(nextProps, 'exportCompensateData')) {
      window.open(get(nextProps, 'exportCompensateData'))
      nextProps.resetExportCompensate()
    }
    const compensateReport = get(nextProps, 'getCompensateReportData.compensateReport')
    if (get(compensateReport, 'compensateReport')) {
      set(tempState, 'compensateReport', reportHelper.generateCompensateReportList(
        get(compensateReport, 'compensateReport'),
        get(compensateReport, 'users'),
        get(compensateReport, 'projects')
      ))
      set(tempState, 'users', get(compensateReport, 'users'))
      set(tempState, 'projects', get(compensateReport, 'projects'))
      nextProps.resetGetCompensateReport()
    }
    if (get(nextProps, 'cancelCompensateReportData.canceledCompensate')) {
      const status = get(nextProps, 'cancelCompensateReportData.status')
      const message = get(nextProps, 'cancelCompensateReportData.message')
      nextProps.showConfirm('cancelCompensate', status, message)
      nextProps.resetCancelCompensateReport()
      nextProps.getCompensateReport(moment(prevState.startDate), moment(prevState.endDate), localStorage.getItem('access_token'))
    }
    return tempState
  }

  state={
    startDate: moment().startOf('month'),
    endDate: moment().endOf('month'),
    showCompensate: false,
    showCancel: false,
  }

  componentDidMount() {
    const access_token = localStorage.getItem('access_token')
    this.props.getAuth(access_token)
    this.props.getCompensateReport(moment().startOf('month'), moment().endOf('month'), access_token)
  }

  handleDate = (type, data) => {
    const access_token = localStorage.getItem('access_token')
    const { startDate, endDate } = this.state

    switch (type) {
      case 'start_date': {
        this.setState({ startDate: data })
        this.props.getCompensateReport(moment(data).format('YYYY-MM-DD'), moment(endDate).format('YYYY-MM-DD'), access_token)
        break
      }
      default: {
        this.setState({ endDate: data })
        this.props.getCompensateReport(moment(startDate).format('YYYY-MM-DD'), moment(data).format('YYYY-MM-DD'), access_token)
        break
      }
    }
  }

  handleClickRow = (requestID, data) => {
    this.setState({
      showCompensate: !this.state.showCompensate,
      data,
      requestID,
    })
  }

  cancelCompensateReport = () => {
    const payload = { remark: this.state.cancelRemark }
    this.props.cancelCompensateReport(this.state.requestID, payload, localStorage.getItem('access_token'))
    this.setState({ cancelRemark: '', showCancel: !this.state.showCancel })
  }

  render() {
    const isFetching = get(this.props, 'getIsFetching')
    const IsSystemUser = get(this.props, 'authData.user.is_system_admin')
    const IsHRConfidentialUser = get(this.props, 'authData.user.is_hr_admin_confidential_role')
    const IsHRUser = get(this.props, 'authData.user.is_hr_admin_role')
    const IsLOBLeadUser = get(this.props, 'authData.user.is_lob_lead_role')
    const IsManagementUser = get(this.props, 'authData.user.is_management_role')
    const IsPMUser = get(this.props, 'authData.user.is_pm_role')

    const isAuthenticated = get(this.props, 'redirectAuth.isAuthenticated')
    || get(this.props, 'redirectReport.isAuthenticated')
    const redirect = get(this.props, 'redirectAuth.redirect')
    || get(this.props, 'redirectReport.redirect')
    if (redirect) {
      localStorage.clear()
      if (isAuthenticated) localStorage.setItem('bad_token', true)
      this.props.resetAuth()
      window.location = '/'
    }
    if (IsLOBLeadUser !== undefined &&
      IsHRUser !== undefined &&
      IsHRConfidentialUser !== undefined &&
      IsManagementUser !== undefined &&
      IsPMUser !== undefined &&
      IsSystemUser !== undefined &&
      !(IsSystemUser || IsLOBLeadUser || IsHRUser || IsHRConfidentialUser || IsManagementUser || IsPMUser)) window.location = '/home'
    const buttonTryAgain = (type) => <Button color='warning' onClick={ () => this.props.hideConfirm(type) }>Try Again</Button>
    const buttonOK = (type) => <Button color='success' onClick={ () => this.props.hideConfirm(type) }>OK</Button>
    return (
      /* eslint no-underscore-dangle: 0 */
      <Wrapper fluid>
        <Searchbar
          { ...this.state }
          handleDate={ (type, data) => this.handleDate(type, data) }
          exportCompensate={ this.props.exportCompensate }
          handleSearch={ (search) => this.setState({ searchCompensate: search }) }
        />
        <CustomModalMessage
          hide={ () => this.props.hideConfirm(get(this.props, 'confirmType')) }
          show={ get(this.props, 'confirmType') === 'cancelCompensate' }
          type={ get(this.props, 'confirmStatus') }
          message={ get(this.props, 'confirmMessage') }
          button={ get(this.props, 'confirmStatus') === 200 ? buttonOK(get(this.props, 'confirmType')) : buttonTryAgain(get(this.props, 'confirmType')) }
        />
        <CancelCompensateWorkForm
          open={ this.state.showCancel }
          toggle={ () => this.setState({ showCancel: !this.state.showCancel }) }
          handleCancelRemark={ (e) => this.setState({ cancelRemark: e.target.value }) }
          cancelCompensateReport={ this.cancelCompensateReport }
        />
        <Compensate
          showDetail={ this.state.showCompensate }
          handleDetail={ () => this.setState({ showCompensate: !this.state.showCompensate }) }
          data={ this.state.data }
          authData={ get(this.props, 'authData') }
          showCancel={ () => this.setState({
            showCancel: !this.state.showCancel,
            showCompensate: !this.state.showCompensate,
          }) }
        />
        { isFetching &&
          <Overlay>
            <OverlayWrapper>
              <BeatLoader
                css={ css(`
                  position: absolute;
                  left: 50%;
                  top: 50%;
                `) }
                sizeUnit={ "px" }
                size={ 15 }
                color={ '#D44B49' }
                loading={ isFetching }
              />
            </OverlayWrapper>
          </Overlay>
        }
        <CompensateWorkTable
          searchCompensate={ this.state.searchCompensate }
          compensateReport={ this.state.compensateReport }
          users={ this.state.users }
          projects={ this.state.projects }
          handleClickRow={ this.handleClickRow }
        />
      </Wrapper>
    )
  }
}
CompensateWorkReport.propTypes = {
  getAuth: PropTypes.func.isRequired,
  showModal: PropTypes.func.isRequired,
  hideModal: PropTypes.func.isRequired,
  showConfirm: PropTypes.func.isRequired,
  hideConfirm: PropTypes.func.isRequired,
  resetAuth: PropTypes.func.isRequired,
  exportCompensate: PropTypes.func.isRequired,
  getCompensateReport: PropTypes.func.isRequired,
  cancelCompensateReport: PropTypes.func.isRequired,
  resetCancelCompensateReport: PropTypes.func.isRequired,
}

const mapStateToProps = (state, props) => createStructuredSelector({
  modalStatus: modalSelector.modalStatus,
  modalType: modalSelector.modalType,
  modalMessage: modalSelector.modalMessage,
  confirmStatus: modalSelector.confirmStatus,
  confirmType: modalSelector.confirmType,
  confirmMessage: modalSelector.confirmMessage,
  authData: authSelector.getAuth,
  getIsFetching: reportSelector.getIsFetching,
  redirectAuth: authSelector.redirectAuth,
  redirectReport: reportSelector.redirectReport,
  exportCompensateData: reportSelector.exportCompensateData,
  getCompensateReportData: reportSelector.getCompensateReportData,
  cancelCompensateReportData: reportSelector.cancelCompensateReportData,
})(state, props)
const mapDispatchToProps = dispatch => bindActionCreators({
  showModal: modalAction.showModal,
  hideModal: modalAction.hideModal,
  showConfirm: modalAction.showConfirm,
  hideConfirm: modalAction.hideConfirm,
  getAuth: authAction.auth,
  resetAuth: authAction.resetAuthUser,
  getCompensateReport: reportAction.getCompensateReport,
  resetGetCompensateReport: reportAction.resetGetCompensateReport,
  exportCompensate: reportAction.exportCompensateReport,
  resetExportCompensate: reportAction.resetExportCompensateReport,
  cancelCompensateReport: reportAction.cancelCompensateReport,
  resetCancelCompensateReport: reportAction.resetCancelCompensateReport,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(withLayout(CompensateWorkReport))

const Wrapper = styled(Container)`
  padding: 0px;
`
const Overlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 1;
`
const OverlayWrapper = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
`



// WEBPACK FOOTER //
// ./src/pages/report/compensate-work/index.js